import React, { useState } from 'react';

import { BringgPopover, Button } from '@bringg/react-components';
import {
	DraggableItem,
	DraggableListSelector,
	useDraggableListSelectorTranslations
} from '@bringg-frontend/draggable-list-selector';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import useRoutesMonitoringTranslations from '../../hooks/use-routes-monitoring-translations';

export interface ColumnConfigProps {
	columnsConfig: {
		selectedValues: DraggableItem[];
		unselectedValues: DraggableItem[];
	};
	onSelectedColumnsChange: (columns: DraggableItem[]) => void;
	getDefaultColumns: () => { selectedValues: DraggableItem[]; unselectedValues: DraggableItem[] };
}

const ColumnConfig = ({ columnsConfig, onSelectedColumnsChange, getDefaultColumns }: ColumnConfigProps) => {
	const [columnsConfigVisible, setColumnsConfigVisible] = useState<boolean>(false);
	const { columnButton } = useRoutesMonitoringTranslations();
	const { title, defaultButton, searchPlaceholder, selected, nonSelected, empty } =
		useDraggableListSelectorTranslations();

	return (
		<BringgPopover
			destroyOnHide
			content={
				<DraggableListSelector
					translations={{
						title,
						defaultButton,
						searchPlaceholder,
						selected,
						nonSelected,
						empty
					}}
					selectedValues={columnsConfig.selectedValues}
					unselectedValues={columnsConfig.unselectedValues}
					getDefault={getDefaultColumns}
					changeImmediate
					onApply={onSelectedColumnsChange}
					onCancel={() => {
						setColumnsConfigVisible(false);
					}}
				/>
			}
			visible={columnsConfigVisible}
			onVisibleChange={setColumnsConfigVisible}
		>
			<Button type="link" icon={<BringgIcon iconName={BringgFontIcons.Columns} />}>
				{columnButton}
			</Button>
		</BringgPopover>
	);
};

export default ColumnConfig;
